import { Dialog, DialogTitle, DialogContent /* DialogActions, Button */ } from '@material-ui/core'

const ActivityModal = ({
  open,
  onClose,
  title,
  children,
  // onConfirm,
  // confirmText = 'Confirm',
  // cancelText = 'Close',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      {/* <DialogActions>
        <Button
          onClick={onClose}
          color="secondary"
        >
          {cancelText}
        </Button>
        {onConfirm && (
          <Button
            onClick={onConfirm}
            color="primary"
          >
            {confirmText}
          </Button>
        )}
      </DialogActions> */}
    </Dialog>
  )
}

export default ActivityModal
